<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pull-left">
        <router-link to="/marketing/offers" class="btn btn-orange"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>     
  <!--      <div class="pull-right "> 
        <a @click.prevent="handleDelete()" title="Delete" class="btn btn-danger"><i class="ti-trash"></i> Delete</a>
      </div> -->
      <p  class="clearfix"></p>

      <offers-form @on-submit="onOfferSubmit"></offers-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import OffersForm from './OffersForm.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      OffersForm
    },
    data () {
      return {
        offerModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onOfferSubmit (model, isValid) {
        this.offerModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/OffersEdit.vue